import React from 'react';
import {Button} from 'antd';
import {useModelDownloadSideBarModal} from './useModelDownloadSideBarModal';
import SideBarButtonItem from '../../../../layout/common/SideBarButtonItem';
import {tid} from '../../../../../testUtils';
import {MODEL_ACTION_MENU_IDS} from '../../../../../test/types';
import {ModelDetailActionProps} from '../../../actionMenuTypes';
import {canDownloadModelFiles, checkExternalSecurityAPI} from '../../../../../permissions/usePermissions';
import {Download16} from '@carbon/icons-react';
import SubmitButton from '../../../../core/Buttons/SubmitButton';
import {IconButton} from '@mui/material';
import {isModelTheorem} from '../../../../../store/model';

const ModelDownloadActionMenuButton: React.FC<Partial<ModelDetailActionProps>> = (props) => {
  const {ModalComponent, openModal} = useModelDownloadSideBarModal(props);
  const isTHModel = isModelTheorem(props.model);
  const hasPermission = isTHModel ? checkExternalSecurityAPI(props.model) : canDownloadModelFiles(props.model);

  const renderDownloadButton = () => {
    return props.fromDynamicSearch === true ? (
      <IconButton
        aria-label="Download Model"
        size="small"
        className="icon32"
        onClick={openModal}
        {...tid('model-card-download')}
      >
        <Download16 />
      </IconButton>
    ) : (
      <SubmitButton
        onClick={openModal}
        type="button"
        endIcon={<Download16 />}
        {...tid(MODEL_ACTION_MENU_IDS.DOWNLOAD_OVERVIEW)}
        permission={hasPermission}
      >
        Download Model Files
      </SubmitButton>
    );
  };
  return (
    <>
      {props.fromSideBar === true ? (
        <SideBarButtonItem
          {...tid(MODEL_ACTION_MENU_IDS.DOWNLOAD)}
          permission={hasPermission}
          onClick={openModal}
          icon={<Download16 />}
          text="Download Model Entry"
        />
      ) : props.displayAntDesign && hasPermission ? (
        <Button onClick={openModal} type="link" {...tid('model-search-download')}>
          Download
        </Button>
      ) : (
        renderDownloadButton()
      )}
      {ModalComponent}
    </>
  );
};

export default ModelDownloadActionMenuButton;
